var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighFiveHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#003D76",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 11.3 2 22l10.7-3.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFiveHand);
export default __webpack_public_path__ + "static/media/high-five-hand.f44d7b53f2b2c0bc36e81b8857a58056.svg";
export { ForwardRef as ReactComponent };